import FormGroup from "@material-ui/core/FormGroup/FormGroup";
import Typography from "@material-ui/core/Typography/Typography";
import * as React from "react";
import { MemberOfParliamentRequestFactory } from "../../model/autogen/MemberOfParliamentController";
import { MemberOfParliamentModel } from "../../model/autogen/MemberOfParliamentModel";
import { UserLevel } from "../../model/autogen/UserLevel";
import { withEditorPage } from "../../pages/editor-page";
import { WithDefaultStyles, withDefaultStyles } from "../../utils/createStyles";
import { strIsNullOrEmpty } from "../../utils/string";
import { LinkCollectionEditor } from "../link-collection-editor";
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { FormStateHelperComponent } from "./form-state-helper";
import { IContentForm } from "./icontent-form";

export interface IMPProfileProps extends IContentForm<MemberOfParliamentModel> {

}

export interface IMPProfileState extends MemberOfParliamentModel {
    
}

type MPProfileFormComponentProps = IMPProfileProps & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles;

export class MPProfileFormComponent extends React.Component<MPProfileFormComponentProps, IMPProfileState> {
    private counter: number;
    constructor(props: MPProfileFormComponentProps) {
        super(props);
        this.counter = 0;
        this.state = { ...props.item };
    }
    private onChange = (key: keyof IMPProfileState, val: any) =>
        this.setState({[key]: val} as any);
    private onLinkChanged = (index: number, title: string, url: string) => {
        const { links } = this.state;
        if (links[index]) {
            links[index].title = title;
            links[index].url = url;
            this.setState({ links });
        }
    }
    private onAddLink = () => {
        const { links } = this.state;
        links.push({
            id: (this.counter--),
            title: "New Link",
            icon: "web",
            url: "https://"
        });
        this.setState({ links });
    }
    private onRemoveLink = (index: number) => {
        const { links } = this.state;
        links.splice(index, 1);
        this.setState({ links });
    }
    public render(): JSX.Element {
        const { firstName, lastName, topLine } = this.state;
        const { isEditing, classes, item } = this.props;
        const cannotSave = strIsNullOrEmpty(firstName) || strIsNullOrEmpty(lastName) || strIsNullOrEmpty(topLine);
        const submitAction = (isEditing === true) 
            ? MemberOfParliamentRequestFactory.update 
            : MemberOfParliamentRequestFactory.create;
        return <FormStateHelperComponent
                item={item}
                documentItemTypeName="MP Profile Item"
                documentItemTypeNamePlural="MP Profile Items"
                documentTypeName="MP Profiles"
                initialTags={this.state.tags}
                isEditing={this.props.isEditing}
                submitAction={submitAction}
                cannotSave={cannotSave}
                onSaveCompleted={this.props.onSaveCompleted}
                onChange={this.onChange}
        >{({ DocumentItemListEditor, DocumentTagListEditor, DocumentFormSubmitButton, DocumentTextField }: any) => (
            <div className={classes.root}>
                <Typography className={this.props.classes.input}  variant="h5">{(isEditing === true) ? "Edit" : "New"} MP Profile</Typography>
                <FormGroup>
                    <DocumentTextField label="First Name" name="firstName" value={firstName} />
                    <DocumentTextField label="Last Name" name="lastName" value={lastName} />
                    <DocumentTextField label="Top Line" name="topLine" value={topLine} extraProps={{ rows: 2, rowsMax: 4 }} />
                </FormGroup>
                <DocumentItemListEditor />
                <FormGroup>
                    <Typography variant="h6">Links</Typography>
                    <LinkCollectionEditor items={this.state.links} onAdd={this.onAddLink} onChange={this.onLinkChanged} onRemove={this.onRemoveLink} />
                </FormGroup>
                <DocumentTagListEditor />
                <DocumentFormSubmitButton />
            </div>
        )}</FormStateHelperComponent>;
    }
}

// HACK: wrapper to workaround the fact that our current codegen doesn't support argument default values, so there's a signature mismatch
const mpProfileGet = (fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number) => MemberOfParliamentRequestFactory.getById(fetcher, id, false);

const MPProfileFormComponentWithStyles = withDefaultStyles(MPProfileFormComponent) as React.ComponentType<MPProfileFormComponentProps>;

export const MPProfileForm = withSnackbar(withAuthContext(MPProfileFormComponentWithStyles, UserLevel.SystemUser)) as React.ComponentType<IMPProfileProps>;

export const MPProfileEditPage = withAuthContext(withEditorPage(MPProfileForm as any, mpProfileGet), UserLevel.Editor) as React.ComponentType<IMPProfileProps>;


// WEBPACK FOOTER //
// ./src/components/forms/mp-profile.tsx